export const listInvestigationRoadAccidentService =
  (fecth) => async (filters) => {
    try {
      const searchParams = new URLSearchParams(filters).toString();
      const response = await fecth({
        url: `/api/v1/siniestros-viales/investigaciones?${searchParams}`,
      });

      return response;
    } catch (error) {
      throw new Error(error.response?.data?.message || error.message);
    }
  };
